import { string, shape, number } from 'prop-types';

const idlingConsumptionBasicInformationPropTypes = {
  id: number.isRequired,
  itineraryId: number.isRequired,
  idlingConsumptionMotiveId: number.isRequired,
  idlingConsumptionMotive: shape({
    id: number.isRequired,
    description: string.isRequired,
  }),
  idlingConsumptionTime: number.isRequired,
  realIdlingConsumptionTime: number.isRequired,
  idlingConsumptionNumberOfGallon: number.isRequired,
  realIdlingConsumptionNumberOfGallon: number.isRequired,
  observation: string,
};

export default idlingConsumptionBasicInformationPropTypes;
